import { API_BASE_URL } from "../../api";

let sessionEndSent = false;

const cleanToken = (token) => {
    if (!token) return null;
    return String(token).replace(/^Bearer\s+/i, '').trim();
};

export const markCurrentSessionEnded = ({ preferBeacon = true } = {}) => {
    if (sessionEndSent) return;

    const token = cleanToken(sessionStorage.getItem('token'));
    if (!token) return;

    sessionEndSent = true;
    const url = `${API_BASE_URL}/api/auth/logout-beacon`;
    const body = token;

    if (preferBeacon && navigator.sendBeacon) {
        const payload = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        const queued = navigator.sendBeacon(url, payload);
        if (queued) return;
    }

    try {
        fetch(url, {
            method: 'POST',
            body,
            headers: {
                'Content-Type': 'text/plain;charset=UTF-8',
            },
            keepalive: true,
        }).catch(() => {});
    } catch (error) {
        sessionEndSent = false;
    }
};

export const sendSessionHeartbeat = () => {
    const token = cleanToken(sessionStorage.getItem('token'));
    if (!token) return;

    try {
        fetch(`${API_BASE_URL}/api/auth/session-heartbeat`, {
            method: 'POST',
            body: token,
            headers: {
                'Content-Type': 'text/plain;charset=UTF-8',
            },
            keepalive: true,
        }).catch(() => {});
    } catch (error) {
    }
};

export const resetSessionEndMarker = () => {
    sessionEndSent = false;
};
